// extracted by mini-css-extract-plugin
module.exports = {"img":"lifeImg_img__2iLfq"};